type TranslateFn = (key: string, options?: { [key: string]: any }) => string;

const defaultCompanySizeLabels: Record<number, string> = {
  3: "1-3",
  10: "4-10",
  25: "11-25",
  50: "26-50",
  51: "50+",
};

const companySizeTranslationKeys: Record<number, string> = {
  3: "resources.companies.sizes.one_to_three_active_auditors",
  10: "resources.companies.sizes.four_to_ten_active_auditors",
  25: "resources.companies.sizes.eleven_to_twenty_five_active_auditors",
  50: "resources.companies.sizes.twenty_six_to_fifty_active_auditors",
  51: "resources.companies.sizes.more_than_fifty_active_auditors",
};

export const getTranslatedCompanySizeLabel = (
  size: { id: number; name: string },
  translate: TranslateFn,
) => {
  const defaultLabel = defaultCompanySizeLabels[size.id];
  const translationKey = companySizeTranslationKeys[size.id];
  if (!defaultLabel || !translationKey || size.name !== defaultLabel) {
    return size.name;
  }

  return translate(translationKey, { _: size.name });
};
